<template>
  <div class="left_nav">
    <el-menu :default-active="defaultActiveMenuIndex" :collapse="isCollapse" class="el-menu-vertical-demo">
      <el-menu-item index="7" @click="toNewRouter('steam-over-view')" v-if="permissionCodes.indexOf('045001000') !== -1">
        <i class="el-icon-damai-shujulaiyuan" style="font-size: 16px"></i>
        <span slot="title">概览</span>
      </el-menu-item>
      <el-submenu index="1" v-if="permissionCodes.indexOf('045002000') !== -1 || permissionCodes.indexOf('045002004') !== -1">
        <template slot="title">
          <i class="el-icon-damai-shebei2"></i>
          <span>设备管理</span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="1-1" @click="toNewRouter('steam-controller-management')" v-if="permissionCodes.indexOf('045002000') !== -1">集中器管理</el-menu-item>
          <el-menu-item index="1-2" @click="toNewRouter('steam-ammeter-management')" v-if="permissionCodes.indexOf('045002004') !== -1">蒸汽表管理</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <!--<el-menu-item index="5" @click="toNewRouter('steam-account-center')" v-if="permissionCodes.indexOf('004002000') !== -1">-->
      <!--<i class="el-icon-damai-page_shoukuanzhanghu" style="font-size: 20px;"></i>-->
      <!--<span slot="title">收款账户配置</span>-->
      <!--</el-menu-item>-->
      <el-submenu index="2" v-if="permissionCodes.indexOf('045003000') !== -1 || permissionCodes.indexOf('045004000') !== -1">
        <template slot="title">
          <i class="el-icon-damai-ic_zhengqipeizhi"></i>
          <span>蒸汽配置</span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="2-1" @click="toNewRouter('steam-config-center')" v-if="permissionCodes.indexOf('045003000') !== -1">收费配置</el-menu-item>
          <el-menu-item index="2-2" @click="toNewRouter('steam-device-scene-config')" v-if="permissionCodes.indexOf('045004000') !== -1">场景配置</el-menu-item>
          <el-menu-item index="2-3" @click="toNewRouter('steam-config-settle')" v-if="permissionCodes.indexOf('045004005') !== -1">结算配置</el-menu-item>
        </el-menu-item-group>
      </el-submenu>

      <el-submenu index="5" v-if="permissionCodes.indexOf('045005000') !== -1 || permissionCodes.indexOf('045006000') !== -1">
        <template slot="title">
          <i class="el-icon-damai-ic_yongliangtongji"></i>
          <span slot="title">蒸汽统计</span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="5-1" @click="toNewRouter('steam-quantity')" v-if="permissionCodes.indexOf('045005000') !== -1">按蒸汽表统计</el-menu-item>
          <el-menu-item index="5-2" @click="toNewRouter('steam-quantity-public')" v-if="permissionCodes.indexOf('045006000') !== -1">按住户统计</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <el-menu-item index="10" @click="toNewRouter('steam-monitoring')" v-if="permissionCodes.indexOf('045012000') !== -1">
        <i class="el-icon-damai-ic_yongliangjiance"></i>
        <span slot="title">蒸汽量监测</span>
      </el-menu-item>
      <el-menu-item index="4" @click="toNewRouter('steam-rent-money')" v-if="permissionCodes.indexOf('045007000') !== -1">
        <i class="el-icon-damai-jiaofeijilu"></i>
        <span slot="title">余额管理</span>
      </el-menu-item>
      <el-menu-item index="3" @click="toNewRouter('steam-pay-record')" v-if="permissionCodes.indexOf('045008000') !== -1">
        <i class="el-icon-damai-page_shoukuanzhanghu" style="font-size: 20px"></i>
        <span slot="title">充值记录</span>
      </el-menu-item>
      <el-menu-item index="9" @click="toNewRouter('steam-settlement-record')" v-if="permissionCodes.indexOf('045009000') !== -1">
        <i class="el-icon-damai-jiesuantongji"></i>
        <span slot="title">结算记录</span>
      </el-menu-item>
      <el-menu-item index="8" @click="toNewRouter('steam-controller-device-status-log')" v-if="permissionCodes.indexOf('045010000') !== -1">
        <i class="el-icon-damai-zhuangtairizhi"></i>
        <span slot="title">设备状态日志</span>
      </el-menu-item>
      <el-menu-item index="6" @click="toNewRouter('steam-log')" v-if="permissionCodes.indexOf('045011000') !== -1">
        <i class="el-icon-damai-ic_caozuorizhi"></i>
        <span slot="title">操作日志</span>
      </el-menu-item>

      <!-- <div style="line-height: 50px;display: flex;justify-content: flex-start;align-items: center;padding-left: 25px;">
        <i class="el-icon-s-fold" style="font-size: 24px;color: #00a0e6;cursor: pointer;" @click="isCollapse = true" v-if="!isCollapse"></i>
        <i class="el-icon-s-unfold" style="font-size: 24px;color: #00a0e6;cursor: pointer;" @click="isCollapse = false" v-if="isCollapse"></i>
      </div> -->
    </el-menu>
  </div>
</template>

<script>
import navMixin from '../../utils/nav'
import { bus } from '../../utils/bus'

const indexOfRouterNameEntities = Object.entries({
  '1-1': ['steam-controller-management', 'steam-controller-add', 'steam-controller-modify', 'steam-controller-current'],
  '1-2': ['steam-ammeter-management', 'steam-ammeter-add', 'steam-ammeter-modify', 'steam-ammeter-current'],
  '2-1': ['steam-config-center', 'steam-config-modify'],
  '2-2': 'steam-device-scene-config',
  '2-3': 'steam-config-settle',
  3: 'steam-pay-record',
  4: 'steam-rent-money',
  // '5': ['steam-account-center', 'steam-account-modify'],
  '5-1': 'steam-quantity',
  '5-2': 'steam-quantity-public',
  6: 'steam-log',
  7: 'steam-over-view',
  8: 'steam-controller-device-status-log',
  9: 'steam-settlement-record',
  10: 'steam-monitoring',
})

export default {
  name: 'steam-management-nav',
  mixins: [navMixin],
  computed: {
    defaultActiveMenuIndex() {
      const { name: routeName } = this.$route
      const entity = indexOfRouterNameEntities.find(([, routeNames]) => {
        if (routeNames instanceof Array) {
          return routeNames.indexOf(routeName) >= 0
        } else {
          return routeNames === routeName
        }
      })
      return entity && entity[0]
    },
  },
  data() {
    return {
      isCollapse: false,
      permissionCodes: '',
      indexOfRouterNameEntities,
    }
  },
  created() {
    this.permissionCodes = bus.global.permissionCodes
  },
  mounted() {
    bus.vue.$on('changeIsCollapse', (data) => {
      this.isCollapse = data
    })
  },
  methods: {
    toNewRouter(name) {
      this.$router.push({
        name: name,
      })
    },
  },
}
</script>

<style lang="less" scoped>
@import '../../components/CommonStyle/commonNavStyle';
</style>



// WEBPACK FOOTER //
// src/view/SteamManage/SteamManagementNav.vue